








import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	methods: {
		createClick() {
			openEdit(NAME, PageMode.CREATE, { filter: this.props.filter });
		},
		async loadFilter() {
			return null;
		},
	},
});
